
export class Modality {
  name: string = null;
  icon: string = null;
  active_icon: string = null;
  active: boolean = null;
  accelerator: string = null;

  constructor(name: string, icon: string, active_icon: string, active: boolean, accelerator: string) {
    this.name = name;
    this.icon = icon;
    this.active_icon = active_icon;
    this.active = active;
    this.accelerator = accelerator;
  }
}



export class Config {
  modalities: Array<Modality> = [
    new Modality('haptic', '/assets/images/haptic.svg', '/assets/images/haptic-active.svg', true, 'h'),
    new Modality('vision', '/assets/images/visual.svg', '/assets/images/visual-active.svg', true, 'v'),
    new Modality('audio', '/assets/images/audio.svg', '/assets/images/audio-active.svg', false, 'm'),
    new Modality('speech', '/assets/images/voice.svg', '/assets/images/voice-active.svg', false, 's')
  ];
  audioClick: any;
  audioSubtleClick: any;
  theme = 'light-mode';
  scrollImageVisible = true;
  inputActive = false;
  inputFocus = false;
  
  subtleClick: any;
  slideClick: any;
  hardClick: any;
  slideSound: any;
  lockSound: any;
  onOffSwitchSound: any;
  gateLatch: any;
  activePage = 'welcome';
}
